import { initializeApp } from "firebase/app";
import { getAuth, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCG5oXEBFler4Uw4960FcnvHOuJP6z19MM",
  authDomain: "clarice-attandance-app.firebaseapp.com",
  projectId: "clarice-attandance-app",
  storageBucket: "clarice-attandance-app.firebasestorage.app",
  messagingSenderId: "485115343729",
  appId: "1:485115343729:web:442854e832d3b35ec0fcd0",
  measurementId: "G-92418BR40J"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Export Firebase Auth and Firestore
export const auth = getAuth(app);
auth.setPersistence(browserLocalPersistence)
  .catch((error) => {
    console.error("Error setting persistence:", error);
  });


export const db = getFirestore(app);


export default app;